<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>build</v-icon>
          {{ $t('book/admin:worker-role.overview.title') }}
        </h2>

        <DataTable
            :enabled-search="true"
            :headers="headers"
            :data="content"
            checkbox-on-property="requireCertificate"
            icon="edit"
            @clickedButton1="editRole"
            :addBtn="true"
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/worker-role/edit`"
            :addBtnText="$t('buttons:add-specific', { specific: $t('common:role')})"
            sortBy="name"
            @cacheCommit="$store.commit('book/admin/storeWorkerRoleOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.workerRoleOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WorkerRoleService from '@/modules/core/services/worker-role-service';
import DataTable from "../../../core/components/DataTable/DataTable";
import WorkerRole from "@/modules/core/data/worker-role";
import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

export default {
  name: "WorkerRoleOverview",
  components: {
    DataTable
  },
  data() {
    return {
      content: []
    }
  },
  methods: {
    editRole(item) {
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/admin/worker-role/edit/${item.id}`);
    }
  },
  computed: {
    headers() {
      return [
        {text: "ID", value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t("book/admin:worker-role.common.certificate"), value: 'checkbox'},
        {text: "", value: "controls", sortable: false}
      ]
    }
  },
  created() {
    WorkerRoleService.readAllFromAPI(
      (resp) => {
        var response = DataUtils.parseDataToObjectArray(resp.data, WorkerRole);
        if (response == null) {
          this.content = [];
        } else {
          this.content = response;
        }
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:role_plural')}))
        this.$logger.error(error);
      }
    )
  }
}

</script>
<style lang="scss">

.wrap-word {
  word-break: break-all;
}

</style>
